module.exports = __webpack_public_path__ + "static/media/page-statistics-svgrepo-com.bde4aa0d.svg";